<template>
  <div>
    <section-title
      class="mt-3"
      content="Información General"
      :has-line="true"
    />
    <div class="rounded pt-0 pt-md-2 pb-3">
      <div class="row mb-1 mb-md-3">
        <div class="col-md-12">
          <validation-provider
            v-if="!readOnly || copyMode"
            v-slot="{ errors, failedRules }"
            name="name"
            rules="required|no-special-characters"
          >
            <label class="data-title mb-0">Nombre del informe:</label>
            <custom-input
              v-model="model.name"
              :custom-error-msg="
                failedRules.required
                  ? 'El nombre es requerido.'
                  : 'No se permiten caracteres especiales.'
              "
              :error="errors[0]"
              maxlength="60"
              :class="isMobile ? 'w-100' : 'w-36rem'"
              show-char-count
              :disabled="readOnly && !copyMode"
            />
          </validation-provider>
          <div v-else>
            <label class="data-title mb-0">Nombre del informe:</label>
            <p class="font-16 font-weight-bold">{{ model.name }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="data-title mb-0">Descripción del informe:</label>
          <validation-provider
            v-if="!readOnly || copyMode"
            v-slot="{ errors }"
            rules="required"
          >
            <custom-text-area
              v-model="model.description"
              :count-classes="['float-right']"
              custom-error-msg="La descripción de informe es requerida."
              :error="errors[0]"
              :maxlength="3000"
              show-char-count
              :disabled="readOnly && !copyMode"
            />
          </validation-provider>
          <p v-else class="font-16 font-weight-bold">{{ model.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import SectionTitle from 'SectionTitle'
import CustomInput from '@/components/common/form/CustomInput'
import CustomTextArea from 'CustomTextArea'

export default {
  name: 'GeneralInformation',
  components: {
    ValidationProvider,
    SectionTitle,
    CustomInput,
    CustomTextArea,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    copyMode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    counter: 0,
  }),
  computed: {
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    model: {
      get() {
        return this.value || {}
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>
<style scoped>
.w-36rem {
  width: 36rem !important;
}
</style>
